/*
* MOCKUP DATA
*/


/*
* MAIN
*/

// GLOBALS
let map,
  Popup,
  mapPopup,
  icons = [],
  forms = [],
  circles = [],
  heatmap = null,
  actualPoints = [],
  animationTriggered = false,
  circlesLoaded = false,
  formDimensions = {
    width: 0,
    extendedWidth: 0,
  }

const isTablet =  window.matchMedia("(max-width: 1023px)").matches,
  isMobile =  window.matchMedia("(max-width: 768px)").matches

const MAP_ZOOM_BREAKPINT = 20,
  CLASS_EXTENDED_FORM = "c-map-form--extended"

// INIT MAP
const initMap = () => {
  map = new google.maps.Map(document.querySelector(".js-map"), {
    center: { lat: 50, lng: 14 },
    zoom: 20,
    minZoom: 20,
    maxZoom: 20,
    mapTypeControl: false,
    scaleControl: false,
    streetViewControl: false,
    rotateControl: false,
    zoomControl: false,
    disableDefaultUI: true,
    gestureHandling: "none",
    styles: [{
      featureType: "poi",
      elementType: "labels",
      stylers: [{
        visibility: "off"
      }]
    }]
  });
  let centerCoords = map.center

  // CHANGE VIEW LISTENER
  const loadFn = () => {
    if (!circlesLoaded && map.zoom < MAP_ZOOM_BREAKPINT || map.zoom >= MAP_ZOOM_BREAKPINT) {
      loadData(map.center, map.zoom).then(dataLoaded)
    }
    centerCoords = map.center
  }
  const debouncedBoundsLoad = _.debounce(() => {
    if (!animationTriggered) {
      if (Math.abs(map.center.lat() - centerCoords.lat()) + Math.abs(map.center.lng() - centerCoords.lng()) > .005) {
        loadFn()
      }
    }
    animationTriggered = false
  }, 1000)
  const debouncedZoomLoad = _.debounce(() => {
    if (!animationTriggered) {
      loadFn()
    }
    animationTriggered = false
  }, 1000)
  map.addListener("bounds_changed", debouncedBoundsLoad)
  map.addListener("zoom_changed", debouncedZoomLoad)

  // GET FORM DIMENSIONS
  const $form = document.getElementById("js-map-form-data")
  $form.style.display = "block"
  formDimensions.width = $form.clientWidth
  $form.classList.add(CLASS_EXTENDED_FORM)
  formDimensions.extendedWidth = $form.clientWidth
  $form.classList.remove(CLASS_EXTENDED_FORM)
  $form.style.display = ""

  // FIRST LOAD
  Popup = initCustomPopup(map)
  google.maps.event.addListenerOnce(map, "projection_changed", function () {
    loadData(map.center, map.zoom).then(dataLoaded)
  })
}

let mapData = [];

// LOAD DATA
const loadData = (center, zoom) =>
  new Promise((resolve, reject) => {
    document.querySelector(".o-loading").classList.remove("o-loading--hide")

    const urlParams = new URLSearchParams(window.location.search);
    const address = urlParams.get('address');

    const long = urlParams.get('long');
    const lat = urlParams.get('lat');
    const data = {address: address, long: long, lat: lat};

    $.ajax({
      type : "POST",
      dataType : "json",
      url : "/wp-admin/admin-ajax.php",
      data : {action: "get_addresses", data: data},
      success: function(response) {
        mapData = response.data;

        setTimeout(() => {
          resolve(mapData)
        }, 1000)
      },
      error: () => {
        window.location.href = "/"
      }
    });
  })

// DATA LOADED
const dataLoaded = data => {
  document.querySelector(".o-loading").classList.add("o-loading--hide")

  // CLEAR & DRAW OVERLAYS
  if (map.zoom < MAP_ZOOM_BREAKPINT) {
    icons.forEach(icon => {
      icon.setMap(null)
    })
    icons = []
    forms.forEach(form => {
      form.setMap(null)
    })
    forms = []
    if (mapPopup) {
      mapPopup.setMap(null)
      mapPopup = null
    }
    actualPoints = []
    // drawCircles(data, map)
    drawHeatMap(data, map)
    circlesLoaded = true
  } else {
    circles.forEach(circle => {
      circle.setMap(null)
    })
    circles = []
    if (heatmap) {
      heatmap.setMap(null)
      heatmap = null
    }
    initMarkers(data, map, Popup)
    circlesLoaded = false
  }
}

/*
* DRAWING ON MAP
*/

const drawCircles = (points, map) => {
  points.forEach(point => {
    if (actualPoints.find(actualPoint => actualPoint.id === point.id)) {
      return
    }
    const addressCircle = new google.maps.Circle({
      fillColor: point.status === 2 ? "#20c68a" : (point.status === 1 ? "#e97745" : "#d44040"),
      fillOpacity: 0.5,
      strokeWeight: 0,
      map,
      center: point,
      radius: 5,
    });
    circles.push(addressCircle)
  })
}

const drawHeatMap = (points, map) => {
  const heatmapData = []
  points.forEach(point => {
    if (point.status === 2 || point.status === 1) {
      const latLng = new google.maps.LatLng(point)
      heatmapData.push({ location: latLng, weight: point.status === 2 ? 10 : 1 })
    }
  })
  heatmap = new google.maps.visualization.HeatmapLayer({
    data: heatmapData,
    dissipating: true,
    // gradient: ["rgba(61, 173, 242, 0)", "rgba(61, 173, 242, 1)", "#20C68A", "#20C68A", "#20C68A"],
    // radius: 100,
    map: map,
  })
}

// INIT MARKERS & FORM
const initMarkers = (points, map, Popup) => {
  const $markers = document.querySelector(".js-markers")
  const $map = document.querySelector(".js-map")

  points.forEach(point => {
    // ADD ONLY NEW POINTS
    if (actualPoints.find(actualPoint => actualPoint.id === point.id)) {
      return
    }

    const latLng = new google.maps.LatLng(point.lat, point.lng)
    if (point.active) {
      map.setCenter(latLng)
    }

    // CLONE MARKER
    let $marker
    if (point.status === 0) {
      $marker = $markers.querySelector(".c-popup-marker__marker--red").cloneNode(true)
    } else if (point.status === 1 && point.address.search(/Praha 9 - Vinoř/) === -1) {
      $marker = $markers.querySelector(".c-popup-marker__marker--orange").cloneNode(true)
    } else {
      $marker = $markers.querySelector(".c-popup-marker__marker--green").cloneNode(true)
    }
    const marker = new Popup(latLng, $marker, "c-popup-marker");
    marker.setMap(map);

    icons.push(marker)

    // SHOW POPUP
    if(point.active) {
      animationTriggered = true
      // ACTIVATE MARKER
      const $markers = document.querySelectorAll(".js-map .c-popup-marker__marker"),
        activeClass = 'c-popup-marker__marker--active',
        $activeMarker = marker.containerDiv.querySelector(".c-popup-marker__marker")

      $markers.forEach($marker => {
        if (!$marker.isSameNode($activeMarker)) {
          $marker.classList.remove(activeClass)
        }
      })

      if ($activeMarker.classList.contains(activeClass)) {
        $activeMarker.classList.remove(activeClass)
      }
      else {
        $activeMarker.classList.add(activeClass)
      }

      // SHOW/HIDE POPUP
      if (mapPopup && mapPopup.id === point.id) {
        mapPopup.setMap(null)
        mapPopup = null
      } else {
        if (mapPopup)
          mapPopup.setMap(null)

        $map.classList.remove("o-map--mobile-extended")

        // GENERATE FORM POPUP
        console.log(point)
        formApp.injectNewPoint(point)
        formApp.$nextTick(function () {
          // INSERT POPUP TO MAP
          const $form = document.getElementById("js-map-form-data"),
            $popupForm = $form.cloneNode(true)
          $popupForm.setAttribute("id", "js-map-form")
          mapPopup = new Popup(latLng, $popupForm);
          mapPopup.id = point.id
          mapPopup.setMap(map);
          forms.push(mapPopup)

          // CENTER MAP
          const centerPoint = latLng2Point(latLng, map)

          if (isTablet) {
            centerPoint.x = centerPoint.x + formDimensions.width / 2.5
            centerPoint.y = centerPoint.y + $map.offsetHeight / 2.75
          } else {
            centerPoint.x = centerPoint.x + formDimensions.width / 2
            centerPoint.y = centerPoint.y + $map.offsetHeight / 4
          }
          const targetLatLng = point2LatLng(centerPoint, map)
          smoothCenterAnimation(map, { lat: map.center.lat(), lng: map.center.lng() }, { lat: targetLatLng.lat(), lng: targetLatLng.lng() }, 1000)

          // ADD JS FUNCTIONALITY TO FORM
          setTimeout(() => {
            const $ = jQuery

            const $inputAddress = $("#js-map-form .c-map-form__address")
            $inputAddress.addClass("smartform-whole-address")
            $inputAddress.attr("id", "adresa")
            $("#js-map-form .c-map-form__adress-form").attr("id", "search-submit-form")
            smartform.rebindAllForms(false, () => {
              smartform.getInstance().addAnnounceCallback(announceCallback)
            })
            initSearchForm()

            const $mapForm = document.querySelector("#js-map-form"),
              $formBtn = document.querySelector(".js-extend-btn")

            $formBtn.addEventListener("click", (e) => {
              e.preventDefault()
              if(isMobile) {
                $(".c-map-form__form").clone(true).addClass("c-contact-form--popup").appendTo(".o-main")
                document.querySelectorAll("html, body").forEach(el => {
                  el.classList.add("u-no-scroll")
                })
                $(".c-nav").removeClass("c-nav--hide")
                
                // BACK
                $(".c-contact-form--popup .c-contact-form__header-mobile-back").click(e => {
                  $(".c-contact-form--popup").remove()
                  document.querySelectorAll("html, body").forEach(el => {
                    el.classList.remove("u-no-scroll")
                  })
                })
                initWPCF7()
              } else {
                animationTriggered = true
                $mapForm.classList.toggle(CLASS_EXTENDED_FORM)

                const centerPoint = latLng2Point(latLng, map)
                if (isMobile) {
                  centerPoint.x = centerPoint.x + formDimensions.width / 2
                  $map.classList.add("o-map--mobile-extended")
                  centerPoint.y = centerPoint.y + $map.offsetHeight / 2.5
                  const targetLatLng = point2LatLng(centerPoint, map)
                  smoothCenterAnimation(map, { lat: map.center.lat(), lng: map.center.lng() }, { lat: targetLatLng.lat(), lng: targetLatLng.lng() }, 1)
                } else {
                  centerPoint.x = centerPoint.x + formDimensions.extendedWidth / 2
                  centerPoint.y = centerPoint.y + document.querySelector(".js-map").offsetHeight / 4
                  const targetLatLng = point2LatLng(centerPoint, map)
                  smoothCenterAnimation(map, { lat: map.center.lat(), lng: map.center.lng() }, { lat: targetLatLng.lat(), lng: targetLatLng.lng() }, 1000)
                }
              }
            })

            // INITIALIZE WPCF7 JS
            const initWPCF7 = () => {
              $('div.wpcf7 > form').each(function () {
                wpcf7.init(this);

                jQuery('form.wpcf7-form')
                  .each(function () {
                    const $ajaxLoader = jQuery(this).find('.ajax-loader')
                    if ($ajaxLoader.length > 1)
                      $ajaxLoader.last().remove();
                  });

                  if(isMobile) {
                    const submitText = $(this).find(".c-contact-form__submit span").text()
                    $(this).on("submit", function() {
                      $(this).find(".c-contact-form__submit span").text("")
                    })
                    this.addEventListener('wpcf7submit', () => {
                      $(this).find(".c-contact-form__submit span").text(submitText)
                    }, false)
                  }
              });
            }
            initWPCF7()
          }, 100)
        })
      }
      // ACTIVATE POINT
      marker.containerDiv.dispatchEvent(
        new CustomEvent("click", {})
      )
    }
  })
  // SET ACTUAL POINTS
  actualPoints = [...points]
}

/*
* HELPER FUNCTIONS
*/

const initCustomPopup = (map) => {
  return class Popup extends google.maps.OverlayView {
    constructor(position, content, popupClass = "popup-container") {
      super();
      this.position = position;
      content.classList.add("popup-bubble");
      // This zero-height div is positioned at the bottom of the bubble.
      const bubbleAnchor = document.createElement("div");
      bubbleAnchor.classList.add("popup-bubble-anchor");
      bubbleAnchor.appendChild(content);
      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement("div");
      this.containerDiv.classList.add(popupClass);
      this.containerDiv.appendChild(bubbleAnchor);
      // Optionally stop clicks, etc., from bubbling up to the map.
      Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
    }
    /** Called when the popup is added to the map. */
    onAdd() {
      this.getPanes().floatPane.appendChild(this.containerDiv);
    }
    /** Called when the popup is removed from the map. */
    onRemove() {
      if (this.containerDiv.parentElement) {
        this.containerDiv.parentElement.removeChild(this.containerDiv);
      }
    }
    /** Called each frame when the popup needs to draw itself. */
    draw() {
      const divPosition = this.getProjection().fromLatLngToDivPixel(
        this.position
      );
      // Hide the popup when it is far out of view.
      const display =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
          ? "block"
          : "none";

      if (display === "block") {
        this.containerDiv.style.left = divPosition.x + "px";
        this.containerDiv.style.top = divPosition.y + "px";
      }

      if (this.containerDiv.style.display !== display) {
        this.containerDiv.style.display = display;
      }
    }
  }
}

const smoothCenterAnimation = (map, startLatLng, endLatLng, duration) => {
  let start

  function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2
  }

  const step = timestamp => {
    if (start === undefined)
      start = timestamp
    const elapsed = timestamp - start
    const end = start + duration

    const getCoord = (coordType) =>
      startLatLng[coordType] + ((endLatLng[coordType] - startLatLng[coordType]) * easeInOutSine(elapsed / duration))

    const actualLatLng = {
      lat: getCoord('lat'),
      lng: getCoord('lng'),
    }
    map.setCenter(actualLatLng)

    if (elapsed < duration) {
      window.requestAnimationFrame(step)
    } else {
      map.setCenter(endLatLng)
    }
  }

  window.requestAnimationFrame(step)
}

function latLng2Point(latLng, map) {
  var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  var scale = Math.pow(2, map.getZoom());
  var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
  return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

function point2LatLng(point, map) {
  var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  var scale = Math.pow(2, map.getZoom());
  var worldPoint = new google.maps.Point(point.x / scale + bottomLeft.x, point.y / scale + topRight.y);
  return map.getProjection().fromPointToLatLng(worldPoint);
}
